/** Hand-drawn 24px stroke icons (no icon library). Decorative by default (aria-hidden). */
const PATHS = {
  home: "M3 10.5 12 3l9 7.5M5 9.5V20h5v-6h4v6h5V9.5",
  plus: "M12 5v14M5 12h14",
  studio: "M4 5h16v10H4zM8 19h8M12 15v4M9.5 8.5l4 1.5-4 1.5z",
  send: "M4 12 20 4l-6 16-2.5-6.5z",
  publish: "M12 16V4m0 0-4.5 4.5M12 4l4.5 4.5M4 15v4h16v-4",
  inbox: "M4 13h4.5l1.5 2.5h4l1.5-2.5H20M4 13l2.5-8h11l2.5 8v6H4z",
  chart: "M4 20V10m5.5 10V4M15 20v-7m5.5 7V8",
  settings: "M12 9a3 3 0 1 0 0 6 3 3 0 0 0 0-6zm8 3-2.1-.6.9-2-2-2-2 .9L12 4l-.8 2.3-2-.9-2 2 .9 2L4 12l2.1.8-.9 2 2 2 2-.9L12 20l.8-2.1 2 .9 2-2-.9-2z",
  stop: "M7 7h10v10H7z",
  check: "m5 12.5 4.5 4.5L19 7.5",
  x: "M6 6l12 12M18 6 6 18",
  alert: "M12 4 2.5 20h19zM12 10v4.5M12 17.2v.1",
  clock: "M12 7v5l3 2M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18z",
  play: "M8 5.5v13l10.5-6.5z",
  chevronRight: "m9.5 6 6 6-6 6",
  chevronDown: "m6 9.5 6 6 6-6",
  back: "M15 5.5 8.5 12l6.5 6.5",
  share: "M8.5 10.5 15.5 6.5M8.5 13.5l7 4M6 9.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM18 3.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zm0 12a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5z",
  upload: "M12 16V5m0 0-4 4m4-4 4 4M5 19h14",
  link: "M10 14a4 4 0 0 0 5.7 0l3-3a4 4 0 0 0-5.7-5.7l-1 1M14 10a4 4 0 0 0-5.7 0l-3 3a4 4 0 0 0 5.7 5.7l1-1",
  refresh: "M20 11a8 8 0 0 0-14.5-4.5L4 8m0-4v4h4M4 13a8 8 0 0 0 14.5 4.5L20 16m0 4v-4h-4",
  pause: "M8 5v14M16 5v14",
  flag: "M5 21V4m0 0h11l-2 4 2 4H5",
  sparkle: "M12 3.5 13.8 10l6.7 2-6.7 2L12 20.5 10.2 14l-6.7-2 6.7-2z",
  user: "M12 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm-7 8a7 7 0 0 1 14 0",
  message: "M4 5h16v11H9l-5 4z",
  edit: "M4 20h4L19 9l-4-4L4 16zM13.5 6.5l4 4",
  volume: "M4 9.5h4l5-4v13l-5-4H4zM16.5 9a4 4 0 0 1 0 6",
  lock: "M6 11h12v9H6zM8.5 11V8a3.5 3.5 0 0 1 7 0v3",
  calendar: "M4 6h16v14H4zM4 10h16M8 3.5v4M16 3.5v4",
  arrowUp: "M12 19V5m0 0-6 6m6-6 6 6",
  bell: "M6 16V11a6 6 0 0 1 12 0v5l1.5 2h-15zM10 20.5a2 2 0 0 0 4 0",
  arrowDown: "M12 5v14m0 0-6-6m6 6 6-6",
  bulb: "M9 18h6M10 21h4M12 3a6 6 0 0 0-3.5 10.9c.6.5 1 1.2 1 2V16h5v-.1c0-.8.4-1.5 1-2A6 6 0 0 0 12 3z",
  book: "M5 4.5h10.5a2 2 0 0 1 2 2V20H7a2 2 0 0 1-2-2zM5 18a2 2 0 0 1 2-2h10.5",
  external: "M14 4h6v6M20 4l-9 9M18 14v6H4V6h6",
  branch: "M7 4v10M7 14a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 4a3 3 0 1 0 0 6 3 3 0 0 0 0-6zM17 10c0 4-10 2-10 6",
  download: "M12 4v11m0 0-4.5-4.5M12 15l4.5-4.5M4 16v4h16v-4",
  trash: "M4 7h16M10 11v6M14 11v6M6 7l1 13h10l1-13M9 7V4h6v3",
} as const;

export type IconName = keyof typeof PATHS;

export function Icon({ name, size = 22, label, className }: { name: IconName; size?: number; label?: string; className?: string }) {
  return (
    <svg
      className={className} width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor"
      strokeWidth={1.8} strokeLinecap="round" strokeLinejoin="round"
      aria-hidden={label ? undefined : true} role={label ? "img" : undefined} aria-label={label} focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
